/** 钱包类型 */
export enum WalletType {
  NOT = 0,
  /** 云钱包，托管钱包 */
  CLOUD = 1,
  /** mpc钱包 */
  MPC = 2,
  /** AA钱包 */
  AA = 3,
  /** 私钥钱包 */
  PRIVATE_KEY = 4,
  /** 助记词钱包 */
  MNEMONIC_PHRASE = 5,
  /** 观察者钱包 */
  FOLLOW_ADDRESS = 6,
  /** metamask钱包或其他三方钱包 */
  THIRD_PARTY = 7,
}

export enum WalletTypeString {
  /** 云钱包，托管钱包 */
  WalletType1 = 'CLOUD',
  /** mpc钱包 */
  WalletType2 = 'MPC',
  /** AA钱包 */
  WalletType3 = 'AA',
  /** 私钥钱包 */
  WalletType4 = 'PRIVATE_KEY',
  /** 助记词钱包 */
  WalletType5 = 'MNEMONIC_PHRASE',
  /** 观察者钱包 */
  WalletType6 = 'FOLLOW_ADDRESS',
  /** metamask钱包或其他三方钱包 */
  WalletType7 = 'THIRD_PARTY',
}

type Point = {
  assetAmount: string;
  dateTime: string;
};

export type getChartDataParams = {
  walletType: string;
  walletId: string;
  chainId: string;
  beginTime: string;
  endTime: string;
};

export type getChartDataRes = {
  point: Point[];
};

export type getDefiDataRes = {
  detail: any[];
};

export type getInscriptionDataRes = {
  result: {
    detail: [];
  };
};

export type getNftDataParams = {
  accountAddress: string;
  cursor: string;
  limit: number;
  chainCode: string;
};

export type getNftDataRes = {
  total: number;
  next: null | string;
  content: {
    contentType: string;
    contentUri: string;
    interactProgram: string;
    collection: string;
    imageUri: string;
    name: string;
    tokenAddress: string;
    latestTradePrice: string | null;
    latestTradeSymbol: string | null;
  }[];
};

export type NftBalance = {
  amount: number;
  contractAddress: string;
  contractName: string;
  contractType: number;
  id: string;
  nftName: string;
  tokenId: string;
  contentType: string;
  contentUri: string;
  imageUri: string;
  riskNft: boolean;
  latestTradePrice: string;
  latestTradeSymbol: string;
};
/** 链类型 */
export enum WalletChainTypes {
  EVM = 1,
  SUI = 2,
  SOLANA = 3,
  BTC = 4,
}

/** 币种 */
export type WalletToken = {
  chainId: string;
  chainCode: string;
  chainName: string;
  symbol: string;
  price: string;
  decimals: number;
  contract: string;
  iconDayUrl: string;
  iconNightUrl: string;
  type: number;
};

/** 币种资产 */
export type WalletChainTokenBalance = WalletToken & {
  name?: string;
  balance: string;
  balanceUsd: string;
};

/** 链资产 */
export type WalletChainBalance = {
  address: string;
  chainId: string;
  chainCode: string;
  chainType: WalletChainTypes;
  amountUsd: string;
  tokenInfo: Array<WalletChainTokenBalance>;
};

/** 链数据 */
export type Chain = {
  /** 链ID */
  chainId: number;
  /** 链Code */
  chainCode: string;
  /** 链名称 */
  chainName: string;
  /** 日间图标 */
  iconDayUrl: string;
  /** 夜间图标 */
  iconNightUrl: string;
  /** 基础币种 */
  baseTokenName: string;
  /** @deprecated 基础币种 */
  baseToken: string;
  /** 网络 */
  networkName: string;
  /** 排序  */
  order: number;
  /** 支持L1的Gas */
  isSupportL1Gas: number;
  /** 链类型 */
  chainType: WalletChainTypes;
  /** 区分EIP1559，暂时无用 */
  gasType: 1;
  /** txAddress */
  txAddress: string;
  /** 链是否开放 */
  tmpStatus: 'open' | 'close';
  /** 创建时间 */
  createAt: number;
  /** 最小交易金额 */
  minTransaction: string;
};

export enum SwapScene {
  //  Swap
  Swap = 'Swap',
  //  Dex pro
  DexPro = 'DexPro',
}

export type SwapChain = Chain & {
  defaultFromTokenAddress: string;
  defaultToTokenAddress: string;
  supportSceneConfig: Array<{
    defaultToTokenAddress: string;
    defaultToTokenSymbol: string;
    scene: SwapScene;
  }>;
  gasLimit?: string;
};
